module.exports = __webpack_public_path__ + "dc14fe432731181bdfef29e908b8720e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/img/stealth-logo2.png
 ** module id = 675
 ** module chunks = 0
 **/